import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientComponent } from './client/client.component';
import { AdminComponent } from './admin/admin.component';
import { StartComponent } from './client/start/start.component';
import { PatientInfoComponent } from './client/patient-info/patient-info.component';
import { AuthGuardService } from './service/auth-guard.service';
import { SigninLogComponent } from './admin/signin-log/signin-log.component';
import { LoginComponent } from './client/login/login.component';
import { AdminAuthGuardService } from './service/admin-auth-guard.service';
import { SigninComponent } from './admin/signin/signin.component';
import { PatientTypeComponent } from './client/patient-type/patient-type.component';

const routes: Routes = [
  { path: '', redirectTo: 'Admin/Login', pathMatch: 'full' },
  { path: 'Admin/Login', component: SigninComponent },
  { path: 'Patient/Login', component: LoginComponent },
  {
    path: 'Admin',
    component: AdminComponent,
    children: [
      {
        path: '', redirectTo: 'Login', pathMatch: 'full'
      },
      {
        path: 'Login',  component: SigninComponent
      },
      {
        path: 'SignIn-Log', canActivate: [AdminAuthGuardService], component: SigninLogComponent
      }
    ]
  },

  {
    path: 'Patient',
    canActivate: [AuthGuardService],
    component: ClientComponent,
    children: [
      {
        path: '', redirectTo: 'Login', pathMatch: 'full'
      },
      {
        path: 'Login' ,  component: LoginComponent
      },
      {
        path: 'SignIn', component: StartComponent
      },
      {
        path: 'Patient-Info', component: PatientInfoComponent
      },
      {
        path: 'Patient-Type', component: PatientTypeComponent
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
